import { render, staticRenderFns } from "./CustomStatCard.vue?vue&type=template&id=51e2b9d4&"
import script from "./CustomStatCard.vue?vue&type=script&lang=ts&"
export * from "./CustomStatCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports